import {
  all,
  call,
  fork,
  put,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";

// Login Redux States
import {
  ACCOUNT_SWITCH,
  EDIT_PROFILE,
  GET_COUNTRIES,
  GET_PROFILE_DETAIL,
  GET_STATE,
  GET_STATE2,
  VALIDATE_URL,
} from "./actionTypes";
import {
  accountSwitchFailed,
  accountSwitchSuccess,
  editProfileFailed,
  editProfileSuccess,
  getProfileDataSucess,
  profileError,
  profileSuccess,
  setCountriesFailed,
  setCountriesSuccess,
  setStateFailed,
  setStateSuccess,
  validateUrlFailed,
  validateUrlSuccess,
} from "./actions";
//restapi end point
import * as constClass from "../../../common/constant/constantURL";
import {
  getAllCounties,
  getStateAndCountry,
  getValidateUrl,
  postFakeProfile,
  postProfileDetail,
  putCall,
  standardPost
} from "../../../helpers/fakebackend_helper";

function* editProfile({ payload: { user, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      // call update detail api
      var url = constClass.REST_API_GET_PROFILE_DETAIL;

      const response = yield call(putCall, url, user);
      yield put(editProfileSuccess(response));

      var obj = JSON.parse(localStorage.getItem("authUser"));
      if (localStorage.getItem("impersonationMode") === undefined) {
        localStorage.clear();
      }
      localStorage.setItem("authUser", JSON.stringify({...obj,name:user.user.name,phoneNumber:user.user.phoneNumber,profileImage:response.profileImage}));
      localStorage.setItem("isAuthProtected", true);
    } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
      const response = yield call(postFakeProfile, {
        username: user.username,
        idx: user.idx,
      });
      yield put(profileSuccess(response));
    }
    // history.push("/profile")
  } catch (error) {
    yield put(editProfileFailed(error));
    yield put(profileError(error));
  }
}

function* getProfileDetail() {
  try {
    let url = constClass.REST_API_GET_PROFILE_DETAIL;
    const response = yield call(postProfileDetail, url);
    // const response = yield call(postProfileDetail, url, {
    //   userId: user,
    // })
    yield put(getProfileDataSucess(response));
  } catch (error) {
    yield put(profileError(error));
  }
}
function* getCountries() {
  try {
    let url = constClass.REST_API_GET_COUNTRIES;

    const response = yield call(getAllCounties, url);

    yield put(setCountriesSuccess(response));
  } catch (error) {
    yield put(setCountriesFailed(error));
  }
}
function* getState({ payload: { user } }) {
  try {
    let url = constClass.REST_API_GET_STATE + user;

    const response = yield call(getStateAndCountry, url);

    yield put(setStateSuccess(response));
  } catch (error) {
    yield put(setStateFailed(error));
  }
}

function* validateUrlHandler(data) {
  try {
    let url = constClass.REST_API_GET_VALIDATE_URL + data.payload;
    const response = yield call(getValidateUrl, url);
    yield put(validateUrlSuccess(response));
  } catch (error) {
    yield put(validateUrlFailed(error));
  }
}

function* handleAccountSwitch(data) {
  try {
    let url = constClass.REST_API_POST_ACCOUNT_SWITCH;
    const response = yield call(standardPost, url, data.payload);
    yield put(accountSwitchSuccess(response));
    let jsonResponse = JSON.parse(JSON.stringify(response));
    if (jsonResponse.accessToken != null) {
      localStorage.setItem("authUser", JSON.stringify(response));
    }
    if (jsonResponse.userType === "ORGANIZATION") {
      window.location = "/dashboard";
    } else if (jsonResponse.userType === "RECRUITER") {
      window.location = "/recruiter/dashboard";
    } else if (jsonResponse.userType === "ADMIN") {
      window.location = "/admin/dashboard";
    }
  } catch (error) {
    yield put(accountSwitchFailed(error));
  }
}

export function* watchProfile() {
  yield takeEvery(EDIT_PROFILE, editProfile);
  yield takeLatest(GET_PROFILE_DETAIL, getProfileDetail);
  yield takeLatest(GET_COUNTRIES, getCountries);
  yield takeLatest(GET_STATE, getState);
  yield takeLatest(GET_STATE2, getState);
  yield takeLatest(VALIDATE_URL, validateUrlHandler);
  yield takeLatest(ACCOUNT_SWITCH, handleAccountSwitch);
}

function* ProfileSaga() {
  yield all([fork(watchProfile)]);
}

export default ProfileSaga;
